"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const eventHandler_1 = require("./eventHandler");
exports.middleware = store => next => action => {
    if (action.type !== 'EMIT_EVENT') {
        return next(action);
    }
    eventHandler_1.handleEvent(action.event, action.payload);
    return next(action);
};



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-website-events/src/middleware.ts